import api from './api';
import { PagedResult } from '@/types';

export interface Supplier {
  id: number;
  name: string;
  code: string;
  businessUnitKey: string;
  businessUnitName: string;
  adjustedName: string;
  contactEmail?: string;
}

export interface CreateSupplierRequest {
  name: string;
  code: string;
  businessUnitKey: string;
  businessUnitName: string;
  adjustedName: string;
  contactEmail?: string;
}

export type UpdateSupplierRequest = CreateSupplierRequest;

export const supplierService = {
  getAll: () => api.get<Supplier[]>('/suppliers'),
  
  getById: (id: number) => api.get<Supplier>(`/suppliers/${id}`),
  
  search: (search: string = '', limit: number = 20, signal?: AbortSignal) =>
    api.get<Supplier[]>(`/suppliers/search?search=${encodeURIComponent(search)}&limit=${limit}`, { signal }),

  // `signal` lets React Query abort stale requests so the server can cancel the SQL query
  searchPaged: (search: string = '', pageNumber: number = 1, pageSize: number = 50, signal?: AbortSignal) =>
    api.get<PagedResult<Supplier>>('/suppliers/search-paged', {
      params: { search, pageNumber, pageSize },
      signal,
    }),
  
  create: (data: CreateSupplierRequest) =>
    api.post<Supplier>('/suppliers', data),
  
  update: (id: number, data: UpdateSupplierRequest) =>
    api.put<Supplier>(`/suppliers/${id}`, data),
  
  delete: (id: number) =>
    api.delete(`/suppliers/${id}`),
};
